

// ------------------------ 🎯 VALIDACIÓN STATUS
const STATUS_REGEX = {
    ERROR: /^5\d{2}$/, // 500–599
    SUCCESS: /^2\d{2}$/, // 200–299
    WARNING: /^4\d{2}$/, // 400–499
};

// ------------------------ 🔥 SHOOT STATUS 
export const isErrorStatusResponse = (CODE) => STATUS_REGEX.ERROR.test(CODE);
export const isSuccessStatusResponse = (CODE) => STATUS_REGEX.SUCCESS.test(CODE);
export const isWarningStatusResponse = (CODE) => STATUS_REGEX.WARNING.test(CODE);
